export default __webpack_public_path__ + "static/media/Avatar-1.955c77b4.png";